import { useAuth } from '../AuthProvider';

export interface UseUserResult {
  user: ReturnType<typeof useAuth>['authUser'];
  appUserId: string | null;
  profile: Record<string, unknown> | null;
  isAuthenticated: boolean;
  /**
   * STABLE SIGNAL: True exactly once after auth initialization completes.
   * Never toggles back to false. Use this to gate API calls in downstream components.
   */
  authReady: boolean;
  loading: boolean;
}

/**
 * Hook to access user information from auth context.
 * 
 * IMPORTANT: Use `authReady` to gate data fetching, not `user` or `isAuthenticated`.
 * The `authReady` signal is stable and only becomes true once per page load,
 * preventing duplicate API calls during Supabase auth event churn.
 */
export function useUser(): UseUserResult {
  const { authUser, appUserId, appProfile, authReady, loading } = useAuth();
  
  return {
    user: authUser,
    appUserId,
    profile: appProfile,
    isAuthenticated: !!authUser,
    authReady,
    loading,
  };
}
